import React from "react";
import { Fan } from "lucide-react";

/**
 * Get icon for fan widget
 * @param {object} widget - Full widget object (optional, for accessing current state)
 * @returns {JSX.Element} Icon component
 */
export const getFanIcon = (widget = null) => {
  // Determine if fan is active (not off)
  const fanMode = widget?.items?.$w1?.value || "";
  const isActive = fanMode && fanMode !== "off";

  const lucideIconProps = {
    size: 24,
    style: {
      paddingBottom: "2px",
    },
  };

  // Use different icon based on state
  return isActive ? <Fan {...lucideIconProps} /> : <Fan {...lucideIconProps} />;
};

export const getFanSubtitle = (widget = null) => {
  if (!widget) return "";

  const fanMode = widget?.items?.$w1?.value || "off";
  const fanSpeed = widget?.items?.$w2?.value;

  if (fanMode === "off") {
    return "Off";
  }

  // Capitalize first letter of mode
  const modeText = fanMode.charAt(0).toUpperCase() + fanMode.slice(1);

  if (fanSpeed !== undefined && fanSpeed !== null) {
    return `${modeText}, ${fanSpeed}%`;
  }

  return modeText;
};

/**
 * Get patterns that this helper supports
 * @returns {string[]} Array of pattern strings
 */
export const getFanPatterns = () => {
  return ["basic.device.fan"];
};
